import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { FETCH_COMPONENTS_REASON } from '../../common/constants/fetch-components-reason.tsx';
import { withGlobalComponentsProperty } from '../../common/services/with-global-components-property/index.tsx';
import { getComponentsPageRequest } from '../../state/actions.tsx';
import { get as getAnalyticsData } from '../../state/analytics/selectors.tsx';
import { isAdmin, getBaseUrl } from '../../state/context/selectors.tsx';
import {
	getProjectKey,
	getProjectName,
	getProjectType,
	isComponentAdminContext,
} from '../../state/project/selectors.tsx';
import type { State } from '../../state/reducer.tsx';
import { initiate as initiateAddComponent } from '../../state/ui/add/actions.tsx';
import { isLoading as isPageLoading } from '../../state/ui/page/selectors.tsx';
import { getStatus } from './selectors.tsx';
import AppView from './view.tsx';

const mapStateToProps = (state: State) => ({
	status: getStatus(state),
	editable: isAdmin(state),
	analyticsData: getAnalyticsData(state),
	baseUrl: getBaseUrl(state),
	projectKey: getProjectKey(state),
	projectName: getProjectName(state),
	projectType: getProjectType(state),
	isAdminContext: isComponentAdminContext(),
	// Toggles to `true` inherently when our `refreshComponents` function is
	// invoked. Resolves to `false` when asynchronous actions are finished.
	isLoading: isPageLoading(state),
});

const mapDispatchToProps = {
	onAddComponent: initiateAddComponent,
} as const;

const mapDispatchToPropsGlobalComponentsProperty = (dispatch: Dispatch) => ({
	onAddComponent: () => {
		dispatch(initiateAddComponent());
	},
	// Refresh cached components when toggling between Compass and Jira components..
	refreshComponents: () => {
		dispatch(
			getComponentsPageRequest({
				page: 0,
				initiatedBy: FETCH_COMPONENTS_REASON.VIEW,
			}),
		);
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(AppView);

export const ContentWithGlobalComponentsProperty = connect(
	mapStateToProps,

	mapDispatchToPropsGlobalComponentsProperty,
)(withGlobalComponentsProperty(AppView));
